'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299'
};

var VIEWS = 1;
var MINS = 2;
var LIKES = 3;
var COMMENTS = 4;
var SHARES = 6;
var ISO = 0;

var UK_AND_IRE = ['GB', 'IE'];

var getEngagements = function getEngagements(vd) {
  return vd[LIKES] + vd[COMMENTS] + vd[SHARES];
};
var getWatchTimeUKIre = function getWatchTimeUKIre(viewingByCountry) {
  var ukAndIre = _lodash2.default.filter(viewingByCountry, function (vd) {
    return _lodash2.default.includes(UK_AND_IRE, vd[ISO]);
  });
  return _lodash2.default.reduce(ukAndIre, function (result, vd) {
    return result + vd[MINS];
  }, 0);
};

var getDemographics = function getDemographics(data, gender) {
  var labels = ['age13-17', 'age18-24', 'age25-34', 'age35-44', 'age45-54', 'age55-64', 'age65-'];
  var demos = _lodash2.default.map(labels, function (label) {
    var dp = _lodash2.default.find(data, function (d) {
      if (d[0] === gender && d[1] === label) {
        return d[2];
      }
    });
    return dp;
  });

  var xxx = _lodash2.default.map(demos, function (d) {
    return d && d[2];
  });
  return xxx;
};

var getGenderPercentages = function getGenderPercentages(data) {
  var maleValues = _lodash2.default.filter(data, function (d) {
    return d[0] === 'male';
  });
  var malePercentage = _lodash2.default.reduce(maleValues, function (sum, d) {
    return sum + d[2];
  }, 0);
  return {
    male: malePercentage,
    female: 100 - malePercentage
  };
};

var Transformer = {
  getInfoSection: function getInfoSection(data) {
    var heroContent = _lodash2.default.find(data.posts, function (p) {
      return p.trackedAsset.platform === 'YOUTUBE';
    });
    return {
      campaignName: data.name,
      influencerName: heroContent && heroContent.influencerName,
      reportDate: new Date()
    };
  },

  getHeroPost: function getHeroPost(data) {
    var heroContent = _lodash2.default.find(data.posts, function (p) {
      return p.trackedAsset.platform === 'YOUTUBE';
    });
    return heroContent;
  },

  getSupportingActivity: function getSupportingActivity(data) {
    var filteredPosts = _lodash2.default.filter(data.posts, function (post) {
      return post.trackedAsset.platform !== 'YOUTUBE';
    });
    var supportingActivity = _lodash2.default.map(filteredPosts, function (post) {
      return {
        platform: _lodash2.default.toLower(post.trackedAsset.platform),
        url: post.trackedAsset.assetURL,
        title: post.text,
        isVideo: post.isVideo,
        views: post.latestStatistic.insights && post.latestStatistic.insights.impressions,
        reach: post.latestStatistic.insights && post.latestStatistic.insights.reach,
        engagements: post.latestStatistic.insights && post.latestStatistic.insights.engagement,
        screenshot: post.thumbnail
      };
    });

    return supportingActivity;
  },

  getSummaryData: function getSummaryData(data) {
    var heroContent = _lodash2.default.find(data.posts, function (p) {
      return p.trackedAsset.platform === 'YOUTUBE';
    });
    var insights = heroContent.latestStatistic.insights;
    var vbc = insights.viewingByCountry;
    var heroEngagements = _lodash2.default.reduce(vbc, function (result, vd) {
      return result + getEngagements(vd);
    }, 0);
    var heroViews = heroContent.latestStatistic.viewCount;

    var filteredPosts = _lodash2.default.filter(data.posts, function (post) {
      return post.trackedAsset.platform !== 'YOUTUBE';
    });

    return {
      totalViews: heroViews,
      totalImpressions: _lodash2.default.reduce(filteredPosts, function (result, post) {
        var ins = post.latestStatistic.insights;
        if (!ins) return result;
        return post.isVideo ? result + (ins.totalVideoImpressions || 0) : result + ins.impressions;
      }, 0),
      totalEngagements: heroEngagements + _lodash2.default.reduce(filteredPosts, function (result, post) {
        var ins = post.latestStatistic.insights;
        if (!ins) return result;
        return post.isVideo ? result : result + ins.engagement;
      }, 0)
    };
  },

  getHeroData: function getHeroData(data) {
    var heroContent = _lodash2.default.find(data.posts, function (p) {
      return p.trackedAsset.platform === 'YOUTUBE';
    });
    var insights = heroContent.latestStatistic.insights;
    var vbc = _lodash2.default.get(insights, 'viewingByCountry', []);
    var demoPercentages = _lodash2.default.get(insights, 'audienceDemographics', []);
    var barData = {
      labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
      datasets: [{
        label: 'male %',
        backgroundColor: dyzioPalette.blue,
        borderColor: dyzioPalette.bgBlue,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'male')
      }, {
        label: 'female %',
        backgroundColor: dyzioPalette.bgPink,
        borderColor: dyzioPalette.pink,
        borderWidth: 1,
        data: getDemographics(demoPercentages, 'female')
      }]
    };

    var genderPercentages = getGenderPercentages(demoPercentages);

    return {
      title: heroContent.title,
      subTitle: _lodash2.default.truncate(heroContent.description, {
        length: 300,
        separator: ' '
      }),
      videoUrl: 'https://www.youtube.com/watch?v=' + heroContent.youtubeVideoId,
      views: heroContent.latestStatistic.viewCount,
      engagements: _lodash2.default.reduce(vbc, function (result, vd) {
        return result + getEngagements(vd);
      }, 0),
      watchTimeUKIre: getWatchTimeUKIre(vbc),
      watchTimeTotal: _lodash2.default.reduce(vbc, function (result, vd) {
        return result + vd[MINS];
      }, 0),
      donutData: {
        labels: ['male %', 'female %'],
        datasets: [{
          data: [genderPercentages.male, genderPercentages.female],
          backgroundColor: [dyzioPalette.blue, dyzioPalette.bgPink],
          borderColor: [dyzioPalette.bgBlue, dyzioPalette.pink],
          borderWidth: 1
        }]
      },
      barData: barData,
      viewingData: _lodash2.default.map(_lodash2.default.take(vbc, 5), function (vd) {
        return {
          name: vd[ISO],
          watchTime: vd[MINS],
          views: vd[VIEWS],
          engagements: getEngagements(vd),
          likes: vd[LIKES]
        };
      })
    };
  }
};

exports.default = Transformer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/hero-report/transformer.js
 ** module id = 2623
 ** module chunks = 0
 **/